import { createActionGroup, props } from '@ngrx/store';

import {
  ForgotPasswordCredentials,
  ResetPasswordCredentials,
  SetPasswordCredentials,
} from '../../models/auth.model';

export const AuthPasswordActions = createActionGroup({
  source: 'Auth',
  events: {
    'Forgot Password': props<ForgotPasswordCredentials>(),
    'Forgot Password Success': props<{ message: string }>(),
    'Forgot Password Failure': props<{ error: string }>(),
    'Reset Password': props<ResetPasswordCredentials>(),
    'Reset Password Success': props<{ message: string }>(),
    'Reset Password Failure': props<{ error: string }>(),
    'Set Password': props<SetPasswordCredentials>(),
    'Set Password Success': props<{ message: string }>(),
    'Set Password Failure': props<{ error: string }>(),
  },
});
